"use client";

import Image from "next/image";

import { cn } from "@/lib/utils";
import {
  FEEDBACK_ICON_DISPLAY_SIZE,
  FEEDBACK_ICON_SRC,
  type FeedbackIconVariant,
} from "@/lib/platform/feedback-icon-paths";

import "@/components/feedback/feedback-icon.css";

type FeedbackIconProps = {
  variant?: FeedbackIconVariant;
  className?: string;
};

export function FeedbackIcon({
  variant = "sidebar",
  className,
}: FeedbackIconProps) {
  const size = FEEDBACK_ICON_DISPLAY_SIZE[variant];

  return (
    <Image
      src={FEEDBACK_ICON_SRC}
      alt=""
      width={size}
      height={size}
      draggable={false}
      unoptimized
      className={cn("feedback-icon", `feedback-icon--${variant}`, className)}
      aria-hidden
    />
  );
}
